import React from 'react';
import styled from 'styled-components';
import {
  TableRenderFn,
  ListingTableData,
  InPersonTableData,
  VirtualTableData,
} from '../types';
import {
  CoopContactEntry,
  StyledTourTableCell,
  StyledMobileTableCell,
  StyledMobileTourTableCell,
} from './components';

export const renderCoopContactEntry: TableRenderFn<
  (ListingTableData | InPersonTableData | VirtualTableData)[number]
> = (_, { coop }, i, opts) => (
  <CoopContactEntry contact={coop} isMobile={opts?.isMobile} />
);

export const buildTableComponents = ({
  md,
  isTourTable,
}: {
  md: boolean;
  isTourTable?: boolean;
}) => {
  const body: any = {
    row: isTourTable && StyledTableRow,
  };
  if (md) {
    if (isTourTable) body.cell = StyledTourTableCell;
  } else if (isTourTable) body.cell = StyledMobileTourTableCell;
  else body.cell = StyledMobileTableCell;
  return { body };
};

const StyledTableRow = styled.tr`
  &:last-child > td {
    border-bottom: 1px solid #f0f0f0 !important;
  }
`;
